<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-100 md-size-100">
      <edit-form ref="edit-form" header-color="green"> </edit-form>
    </div>
  </div>
</template>
<script>
import EditForm from "./CommissionUpdateComponent/CommissionEditForm";

export default {
  components: {
    EditForm
  },
  mounted() {
    this.commissionID = this.$route.params.id;
    this.$store.getCommission(this.commissionID).then(response => {
      this.$refs["edit-form"].agency = response.data.agency.id;
      this.$refs["edit-form"].university = response.data.university.id;
      this.$refs["edit-form"].commission = response.data.commission;
      this.$refs["edit-form"].fix_sum_price = response.data.fix_sum_price;

      // Status
      if (response.data.status === "Full Active") {
        this.$refs["edit-form"].status = 1;
      } else if (response.data.status === "Active") {
        this.$refs["edit-form"].status = 2;
      } else if (response.data.status === "Inactive") {
        this.$refs["edit-form"].status = 3;
      }
    });
  }
};
</script>
